import {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Slider from '@mui/material/Slider';
import TorLink from '../../documents/dialogForms/torLink/TorLink'
import { open } from "../../../redux/actions/modalActions";

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import './UtiBox.css'
import { Title } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

function UtiBox(props) {
  
  const dispatch = useDispatch();

  const createLastActive = () => {
    let index = 0;
    props.items.forEach(item => {
      if (item && !item.includes('טרם')) {
        index++;
      }
    })
    return index;
  }
  const [lastActive, setLastActive] = useState(createLastActive())
  
  const [titles, setTitles] = useState({
    'inStockDate': 'במלאי',
    'shiabudRequestData': props.type === 'Leasing' ? 'טופס הוראת קבע' : 'בקשה לטופס שיעבוד',
    'paymentDate': props.type === 'Leasing' ? 'תשלום פיקדון (אישור העברה ל-3 חודשים)' : 'תשלום',
    'welcomeDate': 'שיחת וולקום',
    'hovaInsur': 'ביטוח חובה',
    'pdiDate': 'התקנות ראשוניות (PDI)',
    'buildingDate': 'בונה ארגז',
    'extraDate': 'התקנות נוספות',
    'Lic': 'תהליך רישוי',
    'qualtiCtrlDate': 'בקרת איכות',
    'deliveryAppoint': 'תיאום מסירה',
    'deliveryDate' : 'מסירה',
    'shildaFormSignDate' : 'חתימה על טופס מסירה (חתימה דיגיטלית)',
    'sirtutSignDate' : 'חתימה על שרטוט'
  })

  const elementMaxWidth = {
    maxWidth: props.width
  };


  let deliveryAppointDiv = null;
  if (props.torLink) {
    deliveryAppointDiv = <a onClick={(e) => dispatch(open('torLink'))} href='#'>לתיאום מסירה</a>;
  }
  
    return (
      <Card style={elementMaxWidth} className='uti-box'>
        <CardHeader title={props.title}></CardHeader>
        <CardContent className='uti-card'>
          <List className='status-icon'>
            {props.items?.filter(item => !props.data || props.data[item] === undefined || props?.data[item] != 'disable').map((item, i) => (
              <div className='status-item'>
                {i > 0 && i < lastActive && <span className='active-box-line'></span>}
                {props.data && props.data[item] && !props.data[item].includes('טרם') ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon style={{color: i == lastActive  ? 'rgba(0, 0, 0, 0.12)' : ''}} />}
              </div>
            ))}
          </List>
          <List className='list-text'>
            {props.items?.filter(item => !props.data || props.data[item] === undefined || props?.data[item] != 'disable').map(item => (
              <ListItem alignItems="flex-start" disablePadding>               
                <ListItemText className='item-text'>
                  <span className='uti-card-title'>{titles[item]}</span>
                  <span className='uti-card-value'>{item == 'deliveryAppoint' && deliveryAppointDiv ? deliveryAppointDiv : (props.data && item != 'paymentDate' ? props.data[item] || '' : '')}</span>
                </ListItemText>
               </ListItem>
            ))}
           </List>
        </CardContent>
       </Card>
    )
}

export default UtiBox
